import { HeroSection } from './components/HeroSection';
import { CompanyShowcase } from './components/CompanyShowcase';
import { FeaturedProducts } from './components/FeaturedProducts';
import { Navbar } from '@/components/feature/Navbar';
import { Footer } from '@/components/feature/Footer';

export default function HomePage() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CompanyShowcase />
        <FeaturedProducts />
      </main>
      <Footer />
    </>
  );
}
